import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaSearch, FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import { Modal, Button, Form } from 'react-bootstrap';

function PackagesList() {
    const [packages, setPackages] = useState([]);
    const [categories, setCategories] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(100);

    // Modal state
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [packageId, setPackageId] = useState(null);

    const [categoryId, setCategoryId] = useState('');
    const [title, setTitle] = useState('');
    const [price, setPrice] = useState('');
    const [description, setDescription] = useState('');

    const fetchPackages = async () => {
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/getpackage`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (!res.ok) throw new Error('Failed to fetch packages');
            const data = await res.json();
            setPackages(data.packages || []);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchCategories = async () => {
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/getcategories`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (!res.ok) throw new Error('Failed to fetch categories');
            const data = await res.json();
            setCategories(data.data || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchPackages();
        fetchCategories();
    }, []);

    const filteredPackages = packages.filter(pkg =>
        pkg && Object.values(pkg).some(value =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    // Pagination
    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentPackages = filteredPackages.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filteredPackages.length / itemsPerPage);

    const handlePageChange = (page) => setCurrentPage(page);

    const resetForm = () => {
        setCategoryId('');
        setTitle('');
        setPrice('');
        setDescription('');
        setPackageId(null);
        setIsEditing(false);
    };

    const handleAddOrEditPackage = async () => {
        const token = localStorage.getItem('authToken');
        const packageData = {
    category_id: Number(categoryId),
    title: title.trim(),
    price,
    description
};

        const method = isEditing ? 'PUT' : 'POST';
        const url = isEditing
            ? `${process.env.REACT_APP_API_URL}/updatepackages/${packageId}`
            : `${process.env.REACT_APP_API_URL}/createpackages`;

        try {
            const res = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(packageData),
            });
            if (!res.ok) throw new Error('Failed to add/update package');
            await fetchPackages();
            setShowModal(false);
            resetForm();
        } catch (error) {
            console.error(error);
        }
    };

    const handleEditClick = (pkg) => {
        setPackageId(pkg.packages_id);
        setCategoryId(pkg.category_id);
        setTitle(pkg.title);
        setPrice(pkg.price);
        setDescription(pkg.description);
        setIsEditing(true);
        setShowModal(true);
    };

    const handleDeleteClick = (id) => {
        setPackageId(id);
        setShowDeleteModal(true);
    };

    const handleDeletePackage = async () => {
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/deletepackages/${packageId}`, {
                method: 'DELETE',
                headers: { Authorization: `Bearer ${token}` },
            });
            if (!res.ok) throw new Error('Failed to delete package');
            await fetchPackages();
            setShowDeleteModal(false);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="container" style={{ marginTop: '80px' }}>
            <h2 className="text-primary">Packages List</h2>

            <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="input-group me-3" style={{ maxWidth: '300px' }}>
                    <span className="input-group-text bg-primary text-white">
                        <FaSearch />
                    </span>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search packages..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <button className="btn btn-success" onClick={() => setShowModal(true)}>
                    <FaPlus /> Add Package
                </button>
            </div>

            <table className="table table-bordered table-striped">
                <thead className="table-primary">
                    <tr>
                        <th>ID</th>
                        <th>Category</th>
                        <th>Title</th>
                        <th>Price</th>
                        <th>Description</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentPackages.map(pkg => (
                        <tr key={pkg.packages_id}>
                            <td>{pkg.packages_id}</td>
                            <td>{categories.find(cat => Number(cat.category_id) === Number(pkg.category_id))?.category || 'Unknown'} </td>
                            <td>{pkg.title}</td>
                            <td>{pkg.price}</td>
                            <td>{pkg.description}</td>
                            <td>
                                <button
                                    className="btn btn-sm btn-outline-success me-2"
                                    onClick={() => handleEditClick(pkg)}
                                >
                                    <FaEdit /> Edit
                                </button>
                                <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleDeleteClick(pkg.packages_id)}
                                >
                                    <FaTrash /> Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Pagination */}
            <nav>
                <ul className="pagination justify-content-center">
                    {[...Array(totalPages)].map((_, idx) => (
                        <li key={idx} className={`page-item ${currentPage === idx + 1 ? 'active' : ''}`}>
                            <button className="page-link" onClick={() => handlePageChange(idx + 1)}>
                                {idx + 1}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>

            {/* Modal */}
            <Modal show={showModal} onHide={() => { resetForm(); setShowModal(false); }}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEditing ? 'Edit Package' : 'Add Package'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Category</Form.Label>
<Form.Select
    value={categoryId}
    onChange={(e) => setCategoryId(e.target.value)}
>
    <option value="">Select Category</option>

    {categories.map((cat) => (
        <option
            key={cat.category_id}
            value={cat.category_id}
        >
            {cat.category}
        </option>
    ))}
</Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                value={title}
                                onChange={e => setTitle(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Price</Form.Label>
                            <Form.Control
                                type="text"
                                value={price}
                                onChange={e => setPrice(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={description}
                                onChange={e => setDescription(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { resetForm(); setShowModal(false); }}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleAddOrEditPackage}>
                        {isEditing ? 'Update' : 'Add'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this package?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeletePackage}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default PackagesList;
